
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
$(function () {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
});

const passwordFields = document.querySelectorAll('.form-password');

if (passwordFields.length > 0) {
    passwordFields.forEach((field) => {
        const toggle = field.querySelector('i');
        const input = field.querySelector('input');

        toggle.addEventListener('click', () => {
            toggle.className === 'fas fa-eye' ? toggle.className = 'fas fa-eye-slash' : toggle.className = 'fas fa-eye';
            input.type === 'password' ? input.type = 'text' : input.type = 'password';
        });
    });
}



// WEBPACK FOOTER //
// ./resources/assets/base/js/app.js